import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cdd1026"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "map"
};
const _hoisted_2 = {
  key: 0,
  id: "mapDialog",
  class: "custom-info-window"
};
const _hoisted_3 = {
  class: "info-content"
};
const _hoisted_4 = {
  key: 0,
  class: "loading-spinner"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "设备信息", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编号：", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "气瓶压力：", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电池电压：", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "信号强度：", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "腔内温度：", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "腔内湿度：", -1));
import { ref, onMounted, watch, nextTick } from 'vue';
import maps from '@/utils/map.js';
import axios from 'axios';
import ActuatorMonitor from '@/views/ActuatorMonitor';
import { bd09togcj02, gcj02towgs84 } from '@/utils/jiup.min.js';
export default {
  __name: 'container',
  setup(__props) {
    let map;
    const showDialog = ref(false);
    const dialogFormVisible = ref(false);
    const showActuatorMonitor = ref(false);

    // 监听 dialog 的打开状态，确保在 dialog 完全打开后再显示模型组件
    watch(dialogFormVisible, newVal => {
      if (newVal) {
        // dialog 打开时，延迟显示模型组件以确保 DOM 完全渲染
        nextTick(() => {
          setTimeout(() => {
            showActuatorMonitor.value = true;
          }, 200); // 给 dialog 动画时间完成
        });
      } else {
        // dialog 关闭时，立即隐藏模型组件
        showActuatorMonitor.value = false;
      }
    });
    const infoWindow = ref({
      show: false,
      actNum: "",
      bottlePressure: null,
      batLevel: null,
      signalStrength: null,
      temp: null,
      humidity: null,
      position: {
        lng: 0,
        lat: 0
      },
      loading: false,
      id: null
    });
    onMounted(() => {
      maps.then(() => {
        BM = window.BM;
        // 确保 Bigemap 的接口请求走线上服务而不是默认的 localhost:3001
        const baseMapUrl = (window.g.bigMapUrl || "").replace(/\/+$/, "");
        if (BM && BM.Config) {
          BM.Config.HTTP_URL = baseMapUrl;
          BM.Config.HTTPS_URL = baseMapUrl;
        }
        let small_icon = BM.icon({
          iconUrl: '../img/mapcz.png',
          iconSize: [100, 100],
          iconAnchor: [10, 20]
        });
        // bigemap.4qx6x8qw
        // bigemap.6ao6lyqn
        // 在ID为map的元素中实例化一个地图，并设置地图的ID号为 bigemap.googlemap-streets，ID号程序自动生成，无需手动配置，并设置地图的投影为百度地图 ，中心点，默认的级别和显示级别控件
        map = BM.map('map', 'bigemap.6ao6lyqn', {
          center: [37.7585334777832, 110.16957092285156],
          zoom: 18,
          zoomControl: true
        });
        let popup = BM.popup();
        axios.get("/安泰管线.geojson").then(({
          data
        }) => {
          // 解决弹窗初始化出现问题
          BM.geoJSON(data, {
            style: function () {
              return {
                color: "#24a3ff",
                // fillColor: all[Math.floor(Math.random() * all.length)],
                weight: 3
                // fillOpacity: 0.9,
              };
            },
            onEachFeature: function (feature, layer) {
              // feature.properties &&
              //   feature.properties.name &&
              //   layer.bindTooltip(feature.properties.name, {
              //     direction: "bottom",
              //     className: "my_tooltip",
              //     permanent: true,
              //   });
              setTimeout(() => {
                showDialog.value = true;
              }, 1000);
              layer.on("click", function (e) {
                console.log(e.target, '当前点击对象--', feature);
                dialogFormVisible.value = true;
                // let mapDialog = document.getElementById("mapDialog");
                // popup.setLatLng(e.latlng).setContent(mapDialog).openOn(map);
              });
            }
          }).addTo(map);
          // // 百度坐标点转换为wgs84
          // let curLocation1=bd09togcj02( 110.19045238474024,37.761206663333525)
          // console.log(curLocation1,'curLocation1')
          // let curLocation2=gcj02towgs84(curLocation1[0], curLocation1[1])
          // console.log(curLocation2,'curLocation2')
          // 打点
          let markerArr = [{
            id: 'device_001',
            actNum: 'MZ001',
            longitude: 110.16957092285156,
            latitude: 37.7585334777832,
            actStatus: 1,
            animationType: ''
          }, {
            id: 'device_002',
            actNum: 'MZ002',
            longitude: 110.17957092285156,
            latitude: 37.7285334777832,
            actStatus: 2,
            animationType: ''
          }];
          markerArr.forEach(item => {
            // marker = BM.marker([item.latitude, item.longitude], {
            //     icon: small_icon
            // })
            // .bindPopup('<p>BIGEMAP</p><p><img src="http://www.bigemap.com/upload/columnthumbnail/20180328/5abb657fa458f.png" alt=""></p>').addTo(map);
            // marker.openPopup()
          });
        });
      });
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [showDialog.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [infoWindow.value.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_7, _createTextVNode(_toDisplayString(infoWindow.value.actNum), 1)]), _createElementVNode("p", null, [_hoisted_8, _createTextVNode(_toDisplayString(infoWindow.value.bottlePressure == null ? '-' : infoWindow.value.bottlePressure) + " MPa", 1)]), _createElementVNode("p", null, [_hoisted_9, _createTextVNode(_toDisplayString(infoWindow.value.batLevel == null ? '-' : infoWindow.value.batLevel) + " %", 1)]), _createElementVNode("p", null, [_hoisted_10, _createTextVNode(_toDisplayString(infoWindow.value.signalStrength == null ? '-' : infoWindow.value.signalStrength) + " %", 1)]), _createElementVNode("p", null, [_hoisted_11, _createTextVNode(_toDisplayString(infoWindow.value.temp == null ? '-' : infoWindow.value.temp) + " ℃", 1)]), _createElementVNode("p", null, [_hoisted_12, _createTextVNode(_toDisplayString(infoWindow.value.humidity == null ? '-' : infoWindow.value.humidity) + " %RH", 1)])])]))])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        width: "70%",
        "close-on-click-modal": false,
        "append-to-body": true,
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogFormVisible.value = $event),
        title: "设备模型",
        class: "model3d1",
        "modal-class": "model3d"
      }, {
        default: _withCtx(() => [showActuatorMonitor.value ? (_openBlock(), _createBlock(_unref(ActuatorMonitor), {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};